/**
 * 試合情報（GetDuelGameInfo の duel）の読み方。再現エンジンのものではない（プロジェクト側の API）ので ocgCore には置かず、
 * 入力画面（/input）・演出の画面（`pages/useDuelMatch.js`）・ocgCore の replay 作成が共通で使う（Issue #497 で
 * 旧演出プレビューと旧 `ocgCore/replayReset.js` の複製を 1 か所に）。
 */

/** 試合の P1 / P2 のデッキ id [P1, P2]（無ければ null）。画面に出しているデッキ → ピン留め → 試合に紐づくデッキ の優先順 */
export const deckIdsOfGame = (game) => [1, 2].map((n) => game?.[`player${n}_deck_info`]?.id ?? game?.[`player${n}_pinned_deck_id`] ?? game?.[`player${n}_deck_id`] ?? null);

/** プレイヤーの色の既定 [P1 = 青, P2 = 赤]。players.color が登録されていないときに、演出の HUD も入力画面もこれを使う */
export const DEFAULT_PLAYER_COLORS = ['#3fa9f5', '#f5563f'];

/** 2 人のプレイヤーの表示情報 [P1, P2]。名前・漢字・色（無ければ DEFAULT_PLAYER_COLORS）・顔・デッキ名・デッキのイラスト・スリーブ */
export function playersFromGame(game) {
  return [1, 2].map((n) => {
    const p = game?.[`player_${n}_info`] ?? {};
    const deck = game?.[`player${n}_deck_info`] ?? {};
    return {
      name: p.name ?? `P${n}`, kanji: p.kanji ?? '', color: p.color || DEFAULT_PLAYER_COLORS[n - 1],
      image: p.image_download_url ?? p.image_thumbnail_url ?? null, deckName: deck.name ?? '',
      deckImage: deck.deck_illust_url ?? deck.deck_illust_thumbnail_url ?? null,   // デッキ管理で上げたイラスト（deckImages/。Issue #346）
      sleeveImage: deck.sleeve_image_url ?? deck.sleeve_image_thumbnail_url ?? null,   // 手札の裏面（Issue #349）
      deckImageFocus: deck.deck_illust_focus ?? null,   // デッキのイラストの中心にしたい点 [fx, fy]（Godot が切り出しに使う。Issue #960）
    };
  });
}

/** デッキの一覧（同じカードは 1 つにまとめて枚数。画像はサムネイル）。GetDeckCards の cards から。入力画面のドローの選び直し（RegisterPanel）が使う */
export function deckList(cards = []) {
  const out = [];
  for (const c of cards) {
    const code = String(c.card_id ?? c.code ?? '');
    if (!code || code === '0') continue;
    const same = out.find((x) => x.code === code);
    if (same) { same.count += 1; continue; }
    out.push({ code, name: c.card_name ?? c.name ?? code, image: c.thumbnail_url ?? c.download_url ?? c.image ?? null, count: 1 });
  }
  return out;
}
